import {
  Timestamp,
  arrayUnion,
  doc,
  addDoc,
  onSnapshot,
  serverTimestamp,
  updateDoc,
  deleteDoc,
  query,
  where,
  collection,
  setDoc,
} from "firebase/firestore";
import { db } from "../firebase";
import { v4 as uuid } from "uuid";
import { customOrderByDESC } from "./helper";

export const getAnswersInRealTimeById = (id, cb) => {
  return onSnapshot(
    query(collection(db, "answers"), where("questionId", "==", id)),
    (doc) => {
      const messageSnaps = [];
      doc.forEach((each) => {
        const temp = each.data();
        const object = {
          ...temp,
          temp: temp.timestamp.seconds,
        };
        messageSnaps.push(object);
      });
      cb(customOrderByDESC(messageSnaps));
    }
  );
};

export const createAnswer = (id, text, senderId) => {
  const answerId = uuid();
  return setDoc(doc(db, "answers", answerId), {
    id: answerId,
    questionId: id,
    text,
    senderId: senderId,
    timestamp: Timestamp.now(),
  });
};

export const updateAnswer = (answerId, text) => {
  return updateDoc(doc(db, "answers", answerId), {
    text,
    editedAt: Timestamp.now(),
  });
};

export const deleteAnswer = (answerId) => {
  return deleteDoc(doc(db, "answers", answerId));
};
